__webpack_require__.p = "/mi-assets/mi-static/mi-legal-renderer/phx-rel-r25.12.3-121225/_next/";